import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

import { styled } from '@mui/system';
import { ReactElement } from 'react';
import Container from '@mui/material/Container';

const CoverContainer = styled('div')({
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});

export type ForCorporateHeaderProps = {
  backgroundImg: string;
};

const ForCorporateHeader = (props: ForCorporateHeaderProps) => {
  const { backgroundImg } = props;
  console.log(backgroundImg);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const MobileView = (): ReactElement => (
    <>
      <CoverContainer
        sx={{
          backgroundImage: `url(${backgroundImg})`,
        }}
      >
        <Grid container justifyContent="center" direction="column" paddingX={2} pt={30} pb={6}>
          <Typography
            sx={{
              position: 'relative',
            }}
            variant="h2"
            color="white"
          >
            Want to host a corporate dinner?
          </Typography>
          <Typography variant="h3" color="white">
            We will help you plan.
          </Typography>
        </Grid>
      </CoverContainer>
    </>
  );

  return isMobile ? (
    <MobileView />
  ) : (
    <CoverContainer
      sx={{
        backgroundImage: `url(${backgroundImg})`,
      }}
    >
      <Container>
        <Grid
          container
          justifyContent="center"
          direction="column"
          sx={{
            padding: {
              sm: '196px 0px 56px 0px',
              md: '196px 0px 56px 0px',
              lg: '282px 0px 89px 0px',
            },
          }}
        >
          <Typography
            sx={{
              position: 'relative',
            }}
            variant="h1"
            color="white"
          >
            Want to host a corporate dinner?
          </Typography>
          <Typography variant="h2" color="white">
            We will help you plan.
          </Typography>
        </Grid>
      </Container>
    </CoverContainer>
  );
};

export default ForCorporateHeader;
